/* global filtro, listas, ordenes */
require('./bootstrap');
// import Carrusel from './modulos/carrusel';
// new Carrusel($("#ctr-enc-carrusel"));

import {carruselListados} from "./modulos/carrusel-listados";

carruselListados();

var $filtro = $("#filtro-lista");

$("#filtro").navigation({
    hideDuration: 600,
    showDelayDuration: 0,
    hideDelayDuration: 0,
    responsive: false
});

$filtro.on("click", "#mostrar-todo", function (e) {
    e.preventDefault();
    $.each(filtro, function (param) {
        if (param !== "orden") {
            delete filtro[param];
        }
    });
    actualizar();
});

$filtro.on("click", "a[data-slug], span[data-slug]", function (e) {
    e.preventDefault();
    var param = $(this).attr("data-param");
    var slug = $(this).attr("data-slug");

    if (param === "orden") {
        filtro[param] = slug;
    } else {
        if (typeof filtro[param] !== 'undefined') {
            if(filtro[param] === slug) {
                delete filtro[param];
            } else {
                filtro[param] = slug;
            }
        } else {
            filtro[param] = slug;
        }
    }
    actualizar();
});
var $ctr = $('#lista-productos');
var pagina = parseInt($ctr.attr("data-pagina"));
var $filtroActivo = $("#filtro-activo");
var url = $filtroActivo.attr("data-url")

function actualizar() {
    $filtroActivo.empty();
    $.each(filtro, function (param, slug) {
        if(param === "orden") {
            $("#orden-activo").text(ordenes[slug]);
        } else if(param !== "pagina") {
            $filtroActivo.append("<span data-param=\""+param+"\" data-slug=\""+slug+"\">" + listas[param][slug] + " <i class=\"fa fa-times\" aria-hidden=\"true\"></i></span>");
        }
    });
    delete filtro['pagina'];
    $.ajax({
        url: $filtroActivo.attr("data-url"),
        type: "POST",
        data: filtro,
        cache: false,
        success: function(html) {
            $("#lista-productos").html(html);
            pagina = 1;
        },
        error: function (jqXHR) {
            console.log('Error', jqXHR.responseText);
        },
        beforeSend: function() {
            $("#cargador").show();
        },
        complete: function() {
            $("#cargador").hide();
        }
    });
}

/* Paginación */
var esperndoPagina = false;

$(window).on("scroll", function() {
    if ($(document).height() - $(window).height() - 450 <= $(window).scrollTop() && esperndoPagina === false) {
        var nuevaPagina = pagina + 1;
        filtro["pagina"] = nuevaPagina;
        var paginas = parseInt($ctr.find(".lista:first").attr("data-paginas"));

        if(nuevaPagina <= paginas) {
            esperndoPagina = true;
            var href = new URL(location.href);
            href.searchParams.set('pagina', "" + nuevaPagina);
            history.replaceState({}, '', href.toString());
            $.ajax({
                url: url,
                type: "POST",
                data: filtro,
                dataType: 'html',
                success: function(html) {
                    $ctr.find(".lista:first").append(html);
                    pagina = nuevaPagina;
                },
                error: function (jqXHR) {
                    console.log('Error', jqXHR.responseText);
                },
                beforeSend: function() {
                    $("#cargador").show();
                },
                complete: function() {
                    $("#cargador").hide();
                    esperndoPagina = false;
                }
            });
        }
    }
});


